export default "/Sunglasses_2.glb";